import { createListenerMiddleware } from '@reduxjs/toolkit'
import {
  createScheduledAssignment,
  updateScheduledAssignment,
  fetchScheduledAssignments,
} from './manage.slice'

export let listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  actionCreator: createScheduledAssignment.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(
      fetchScheduledAssignments(action.payload.linkedServiceID),
    )
  },
})

listenerMiddleware.startListening({
  actionCreator: updateScheduledAssignment.fulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(
      fetchScheduledAssignments(action.payload.linkedServiceID),
    )
  },
})
